var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPerson(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    "data-name": "Warstwa 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 15.9 15.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-4{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#00393f;}.cls-4{stroke:#ffeacb;stroke-width:0.99px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-989.37 -595.7)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 989.37,
    y: 595.7,
    width: 15.9,
    height: 15.9
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M997.32,611.1a7.46,7.46,0,1,0-7.45-7.45,7.46,7.46,0,0,0,7.45,7.45",
    transform: "translate(-989.37 -595.7)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 7.95,
    cy: 7.95,
    r: 7.45
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M997.32,604.51a3,3,0,1,0-3-3,2.95,2.95,0,0,0,3,3",
    transform: "translate(-989.37 -595.7)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 7.95,
    cy: 5.86,
    r: 2.95
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1003.79,607.39c0-2-1.75-3.2-4.22-3.85",
    transform: "translate(-989.37 -595.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1003.79,607.39c0-2-1.75-3.2-4.22-3.85",
    transform: "translate(-989.37 -595.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M995,603.55c-2.45.65-4.19,1.88-4.19,3.84",
    transform: "translate(-989.37 -595.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M995,603.55c-2.45.65-4.19,1.88-4.19,3.84",
    transform: "translate(-989.37 -595.7)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.5cfbda0c.svg";
export { ForwardRef as ReactComponent };